<template lang="pug">
  .contenedor-lista
    .title
      span Mis cursos
    .body
      .information
        template(v-if="lista.length !== 0")
          .curso-item(
            v-for="(o, index) in lista"
            :key="index"
          )
            img.curso-imagen(:src="o.imagen" alt="Curso imagen")
            .curso-detalles
              .curso-header
                span {{ o.titulo | truncateText(20) }}
                .descripcion(v-if="o.descripcion")
                  span {{ o.descripcion | truncateText(30) }}
              .curso-info
                span Duración: {{ o.DuracionTotal }}
                span Clases: {{ o.NumeroClases }}
                span Progreso: {{ o.progreso }}%
            .curso-botones
              button.button.is-primary(v-if="o.progreso === 0" @click="iniciarCurso(o.id)") Iniciar curso
              button.button.is-info(v-if="o.progreso > 0 && o.progreso < 100" @click="iniciarCurso(o.id)") Continuar
              button.button.is-warning(v-if="o.progreso === 100" @click="iniciarCurso(o.id)") Volver a iniciar
      div(v-if="!isLoading && lista.length === 0")
        .message.is-warning
          .message-body No hay cursos registrados
      .is-loading(v-if="isLoading")
        .icon
          i.fa.fa-spinner.fa-spin
</template>


<script>
import { apiGet, apiPost, notify } from '../util/general'

export default {
  name: 'cursos-virtuales-lista',
  data () {
    return {
      lista              : [],
      isLoading          : false
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/curso/virtual/alumno/lista', {}, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    iniciarCurso (id) {
      var vm = this
      vm.verCurso(id)
      .then(() => {
        vm.$router.push('/mis-cursos/' + id + '/clases')
      })
    },
    verCurso (id) {
      return new Promise((resolve, reject) => {
        var vm = this
        vm.isLoading = true
        apiPost(vm, '/curso/virtual/alumno/lista/' + id + '/ver-curso', {}, function (data) {
          resolve(null)
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
          reject(error)
        }, function () {
          vm.isLoading = false
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .curso-item
    display: flex
    align-items: center
    padding: 15px
    border: 1px solid #eaeaea
    border-radius: 5px
    margin-bottom: 15px
    background-color: #fff
    max-width: 100%
    flex-wrap: wrap

  .curso-imagen
    width: 150px
    height: 100px
    object-fit: cover
    border-radius: 5px
    margin-right: 20px

  .curso-detalles
    flex: 1
    min-width: 200px
    .curso-header
      display: block
      span
        font-weight: bold
        display: block
    .descripcion
      margin-top: 5px
      color: #666
      font-size: 14px
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis

    .curso-info
      margin-top: 10px
      span
        display: inline-block
        margin-right: 10px

  .curso-botones
    display: flex
    flex-direction: column
    justify-content: space-between
    align-items: center
    button
      margin-bottom: 5px
      min-width: 120px
  @media (max-width: 820px) and (min-width: 600px)
    .curso-item
      flex-direction: column
      align-items: center
      .curso-detalles
        width: 100%
        text-align: center
        margin-bottom: 10px
      .curso-botones
        flex-direction: row
        width: 100%  // Los botones ocuparán el ancho completo
        justify-content: center
        button
          flex: 1
          margin-right: 5px
        button:last-child
          margin-right: 0

  @media (max-width: 600px)
    .curso-item
      flex-direction: column
      align-items: flex-start
      .curso-imagen
        width: 100%
        height: auto
        margin-bottom: 10px
      .curso-detalles
        width: 100%

        .curso-info
          margin-top: 5px
          margin-bottom: 10px
      .curso-botones
        width: 100%
        button
          width: 100%
          margin-bottom: 5px





  .information
    padding-top 10px


  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
</style>




// WEBPACK FOOTER //
// c_cursos_virtuales_lista.vue?1759ddcb